import { apiGateway } from "@contexts";
import { GetBankTransactionChallengeResponse } from "@interfaces/Esign";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";

interface Props {
  onError: (error: Error) => void;
}

export const useCreateBankTransferChallenge = ({ onError }: Props) => {
  const onSuccess = useCallback(
    ({ simplifiedPaymentUrl }: GetBankTransactionChallengeResponse) => {
      window.location.href = simplifiedPaymentUrl;
    },
    []
  );

  return useMutation({
    mutationFn: () =>
      apiGateway<GetBankTransactionChallengeResponse>({
        url: "/enrolment/bank-transfer-challenge",
        method: "POST",
      }),
    onSuccess,
    onError,
  });
};
